export const NOTIFICATION_SOUNDS_STORAGE_KEY = "live-room-notification-sounds";

let enabled = true;
let initialized = false;
const listeners = new Set<() => void>();

function update(value: boolean) {
  if (enabled === value) return;
  enabled = value;
  for (const listener of listeners) listener();
}

function initialize() {
  if (initialized || typeof window === "undefined") return;
  initialized = true;
  try {
    enabled = window.localStorage.getItem(NOTIFICATION_SOUNDS_STORAGE_KEY) !== "false";
  } catch {
    // Storage can be unavailable; the preference still works for this tab.
  }
  // Keep listening even when no menu is mounted: playback also reads this store.
  window.addEventListener("storage", (event) => {
    if (event.key !== NOTIFICATION_SOUNDS_STORAGE_KEY && event.key !== null) return;
    try {
      if (event.storageArea && event.storageArea !== window.localStorage) return;
    } catch {
      return;
    }
    update(event.newValue !== "false");
  });
}

export function getNotificationSounds() {
  initialize();
  return enabled;
}

export function setNotificationSounds(value: boolean) {
  initialize();
  try {
    window.localStorage.setItem(NOTIFICATION_SOUNDS_STORAGE_KEY, String(value));
  } catch {
    // Keep the in-memory preference reactive if persistence is blocked.
  }
  update(value);
}

export function subscribeNotificationSounds(listener: () => void) {
  initialize();
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
  };
}
